<rap-analytics-ui [analytics]="analytics$ | async" [errorMessage]="errorMessage$ | async"
  [viewAnalytics]="viewAnalytics$ | async" (deleteAnalyticsEmitter)="deleteAnalytics($event)"
  (viewAnalyticsEmitter)="viewAnalytics($event)"></rap-analytics-ui>